import makeStyles from '@mui/styles/makeStyles';
import colors from '../colors';
import fontStyles from '../fontStyles';

const styles = makeStyles(() => ({
  legalDisclaimer: {
    ...fontStyles.bodySmall,
    margin: '24px 0 0',
    color: colors.gray600
  }
}));

export default styles;
